
import { useState, useCallback } from "react";
import { Board, BoardOperation } from "../types";

/**
 * Hook for managing board operations (edit/delete)
 */
export const useBoardOperations = (getBoardById: (id: string) => Board | undefined) => {
  // Simple operation state
  const [operation, setOperation] = useState<BoardOperation>({
    isOpen: false,
    type: null,
    board: null
  });

  // Start edit operation
  const startEditBoard = useCallback((board: Board) => {
    // Ensure we have a full board object with all properties
    const fullBoard = board.id ? getBoardById(board.id) || board : board;
    
    console.log("🔶 Starting edit operation for board:", fullBoard);
    setOperation({
      isOpen: true,
      type: "edit",
      board: { ...fullBoard } // Create a clean copy to avoid reference issues
    });
  }, [getBoardById]);

  // Start delete operation
  const startDeleteBoard = useCallback((board: Board) => {
    // Ensure we have a full board object with all properties
    const fullBoard = board.id ? getBoardById(board.id) || board : board;
    
    console.log("🔴 Starting delete operation for board:", fullBoard);
    setOperation({
      isOpen: true,
      type: "delete",
      board: { ...fullBoard } // Create a clean copy to avoid reference issues
    });
  }, [getBoardById]);

  // Close any open operation
  const closeOperation = useCallback(() => {
    console.log("✅ Closing operation");
    setOperation({
      isOpen: false,
      type: null,
      board: null
    });
  }, []);

  return {
    operation,
    startEditBoard,
    startDeleteBoard,
    closeOperation
  };
};
